(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
const menus = document.querySelectorAll('.menu-sidebar__content.custom-sidebar-and-menu');

menus.forEach(menu => {
  const grids = menu.querySelectorAll('.column-menu-wrap');

  grids.forEach((item) => {
    const grid = item.querySelector('.custom-sidebar-and-menu-grid')
    const computedStyle = getComputedStyle(grid);
    const columnTracks = computedStyle.getPropertyValue('grid-template-columns');
    const columnCount = columnTracks.split(' ').length;

    item.style.setProperty(`--column-count`, columnCount);
  });
});



  } catch(e) { console.error(e); }
})();
})();
